// extracted by mini-css-extract-plugin
module.exports = {"iconBox":"button-like-radio_component_iconBox__Iq7ME","radioView":"button-like-radio_component_radioView__1Xace","radio":"button-like-radio_component_radio__Kqoiu"};